(function () {
  if (window.BHFacetPage2Mounted) return;
  window.BHFacetPage2Mounted = true;

  // ---------------- CSS injecté (pour carrés / ronds / slider) ----------------
  function injectCSSOnce() {
    if (document.getElementById("bhFacetPage2CSS")) return;
    const css = document.createElement("style");
    css.id = "bhFacetPage2CSS";
    css.textContent = `
      /* Carré (Marque/Catégorie) */
      #bhFacetPage2 .bh-square{
        position: relative !important;
        padding-left: 34px !important;
      }
      #bhFacetPage2 .bh-square::before{
        content:"";
        position:absolute;
        left: 6px;
        top: 50%;
        width: 14px;
        height: 14px;
        border: 1px solid rgba(0,0,0,.35);
        transform: translateY(-50%);
        box-sizing: border-box;
        border-radius: 2px;
        background: #fff;
      }
      #bhFacetPage2 .bh-square.active::after{
        content:"";
        position:absolute;
        left: 10px;
        top: 50%;
        width: 6px;
        height: 10px;
        border-right: 2px solid #111;
        border-bottom: 2px solid #111;
        transform: translateY(-55%) rotate(45deg);
      }

      /* Rond couleur */
      #bhFacetPage2 .bh-color-dot{
        width: 14px;
        height: 14px;
        border-radius: 999px;
        display:inline-block;
        margin-right: 10px;
        border: 1px solid rgba(0,0,0,.25);
        vertical-align: middle;
        flex: 0 0 auto;
      }
      #bhFacetPage2 label.mobile-facets__label{
        display:flex;
        align-items:center;
        gap: 0;
      }

      /* Slider prix */
      #bhFacetPage2 .bh-price{ padding: 8px 0 14px; }
      #bhFacetPage2 .bh-line{ position: relative; height: 28px; }
      #bhFacetPage2 .bh-line input[type="range"]{
        position:absolute; left:0; top:0;
        width:100%; height: 28px;
        background: transparent;
        -webkit-appearance: none;
        appearance: none;
        pointer-events: auto;
      }
      #bhFacetPage2 .bh-line input[type="range"]::-webkit-slider-thumb{
        -webkit-appearance: none;
        appearance: none;
        width: 16px; height: 16px;
        border-radius: 999px;
        border: 1px solid rgba(0,0,0,.35);
        background: #fff;
        cursor: pointer;
      }
      #bhFacetPage2 .bh-line input[type="range"]::-moz-range-thumb{
        width: 16px; height: 16px;
        border-radius: 999px;
        border: 1px solid rgba(0,0,0,.35);
        background: #fff;
        cursor: pointer;
      }
      #bhFacetPage2 .bh-track{
        position:absolute; top: 50%;
        transform: translateY(-50%);
        height: 2px;
        background: rgba(0,0,0,.2);
        left: 0; width: 100%;
      }
      #bhFacetPage2 .bh-track-active{
        position:absolute; top: 50%;
        transform: translateY(-50%);
        height: 2px;
        background: rgba(0,0,0,.85);
        left: 0; width: 0;
      }
      #bhFacetPage2 .bh-labels{
        display:flex;
        justify-content: space-between;
        font-size: 12px;
        opacity: .85;
        padding-top: 8px;
      }

      /* On masque le "retour natif" Dawn (flèche) dans le panneau */
      #bhFacetPage2 .mobile-facets__close-button{
        display:none !important;
      }
    `;
    document.head.appendChild(css);
  }

  // ---------------- UI ----------------
  function ensureUI() {
    injectCSSOnce();

    let overlay = document.getElementById("bhFacetPage2Overlay");
    let panel = document.getElementById("bhFacetPage2");

    if (!overlay) {
      overlay = document.createElement("div");
      overlay.id = "bhFacetPage2Overlay";
      document.body.appendChild(overlay);
      overlay.addEventListener("click", (e) => {
  e.preventDefault();
  e.stopPropagation();
  closePage2(true);
}, true);

    }

    if (!panel) {
      panel = document.createElement("div");
      panel.id = "bhFacetPage2";
      panel.innerHTML = `
        <div id="bhFacetPage2Header">
          <button id="bhFacetPage2Close" type="button" aria-label="Fermer">×</button>
          <div id="bhFacetPage2Title"></div>
        </div>
        <div id="bhFacetPage2Body"></div>
      `;
      document.body.appendChild(panel);
      panel.querySelector("#bhFacetPage2Close").addEventListener("click", function(e){
  e.preventDefault();
  e.stopPropagation();
  window.BHFacetClosePage2 && window.BHFacetClosePage2();
}, true);



    }

    overlay.style.cssText = `
      position: fixed !important;
      inset: 0 !important;
      background: rgba(0,0,0,.45) !important;
      z-index: 2147483646 !important;
      display: none !important;
    `;

    panel.style.cssText = `
      position: fixed !important;
      top: 0 !important;
      right: 0 !important;
      height: 100vh !important;
      width: min(420px, 88vw) !important;
      background: #fff !important;
      z-index: 2147483647 !important;
      display: none !important;
      flex-direction: column !important;
      overflow: hidden !important;
      box-shadow: -20px 0 60px rgba(0,0,0,.18) !important;
      border: none !important;
      outline: none !important;
    `;

    const header = panel.querySelector("#bhFacetPage2Header");
    header.style.cssText = `
      display:flex !important;
      align-items:center !important;
      gap:12px !important;
      padding:14px 16px !important;
      border-bottom:1px solid #eee !important;
      background:#fff !important;
    `;

    const closeBtn = panel.querySelector("#bhFacetPage2Close");
    closeBtn.style.cssText = `
      width:34px !important;
      height:34px !important;
      border:0 !important;
      background:transparent !important;
      font-size:22px !important;
      line-height:1 !important;
      cursor:pointer !important;
    `;

    const title = panel.querySelector("#bhFacetPage2Title");
    title.style.cssText = `font-size:14px !important;font-weight:600 !important;`;

    const body = panel.querySelector("#bhFacetPage2Body");
    body.style.cssText = `flex:1 !important;overflow:auto !important;padding:0 16px 16px !important;`;

    return { overlay, panel };
  }

  // ---------------- State ----------------
  let movedNode = null;
  let movedFrom = null;
  let currentOpenDetails = null;
  let currentForm = null;

function closePage2() {
  // remettre le vrai submenu à sa place
  try { if (movedNode && movedFrom) movedFrom.appendChild(movedNode); } catch(e){}
  movedNode = null;
  movedFrom = null;

  // fermer le details niveau 2
  try { if (currentOpenDetails) currentOpenDetails.open = false; } catch(e){}
  currentOpenDetails = null;
  currentForm = null;

  // cacher page2
  const overlay = document.getElementById("bhFacetPage2Overlay");
  const panel = document.getElementById("bhFacetPage2");
  if (overlay) overlay.style.display = "none";
  if (panel) panel.style.display = "none";

  // RESET drawer page 1 (anti blanc)
  const drawer = document.getElementById('Details-FacetDrawer');
  if(!drawer) return;

  drawer.open = true;
  drawer.setAttribute('open','');

  const inner = drawer.querySelector('.mobile-facets__inner');
  const main  = drawer.querySelector('#FacetsWrapperMobile.mobile-facets__main');

  if(inner){
    inner.style.display = 'flex';
    inner.style.visibility = 'visible';
    inner.style.opacity = '1';
    inner.style.transform = 'translateX(0px)';
    inner.style.pointerEvents = 'auto';
  }
  if(main){
    main.style.visibility = 'visible';
    main.style.opacity = '1';
    main.style.transform = 'translateX(0px)';
    main.style.pointerEvents = 'auto';
  }

  drawer.querySelectorAll('details.mobile-facets__details[open]').forEach(d => d.open = false);

  drawer.querySelectorAll('.mobile-facets__submenu').forEach(sm => {
    sm.style.transform = '';
    sm.style.visibility = '';
    sm.style.display = '';
  });
}

// BH — rendre la fermeture accessible partout
window.BHFacetClosePage2 = closePage2;




  // ---------------- Helpers couleurs ----------------
  function normalizeColorLabel(raw) {
    let s = (raw || "")
      .replace(/\(\s*\d+\s*\)/g, "")
      .replace(/\s+/g, " ")
      .trim()
      .toLowerCase();
    s = s.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    return s;
  }

  function colorToCss(label) {
    const s = normalizeColorLabel(label);

    // IMPORTANT : on ne prend que le libellé (sans le count)
    // ex "Rouge (12)" -> rouge
    if (s.includes("multicol")) return "linear-gradient(135deg,#ff5f6d,#ffc371)";
    if (s.includes("noir")) return "#000000";
    if (s.includes("blanc")) return "#ffffff";
    if (s.includes("beige")) return "#e6d3b3";
    if (s.includes("gris") || s.includes("argent")) return "#b3b3b3";
    if (s.includes("marron") || s.includes("brun") || s.includes("camel")) return "#8b5a2b";
    if (s.includes("bleu")) return "#1e4dff";
    if (s.includes("rouge")) return "#d00000";
    if (s.includes("rose")) return "#ff7aa8";
    if (s.includes("jaune")) return "#ffd600";
    if (s.includes("orange")) return "#ff8a00";
    if (s.includes("vert") || s.includes("kaki")) return "#1f6b3a";
    if (s.includes("violet") || s.includes("lilas")) return "#7d4cff";

    // fallback (au lieu du gris vide)
    return "#f0f0f0";
  }

  function applyBrandhubStyles(title, submenu) {
    const t = (title || "").toLowerCase();

    // Carrés marque/catégorie
    if (t.includes("marque") || t.includes("catégorie") || t.includes("categorie")) {
      submenu.querySelectorAll("label.mobile-facets__label").forEach(lab => {
        lab.classList.add("bh-square");
      });
    }

    // Ronds couleur
    if (t.includes("couleur")) {
      submenu.querySelectorAll("label.mobile-facets__label").forEach(lab => {
        if (lab.querySelector(".bh-color-dot")) return;

        // on récupère le vrai texte de label (sans checkbox)
        const labelText = (lab.querySelector(".facet-checkbox__text-label")?.textContent || lab.textContent || "").trim();

        const dot = document.createElement("span");
        dot.className = "bh-color-dot";
        dot.style.background = colorToCss(labelText);

        if (normalizeColorLabel(labelText).includes("blanc")) {
          dot.style.borderColor = "#d1d1d1";
        }

        lab.insertBefore(dot, lab.firstChild);
      });
    }
  }

  function mountPriceSlider(submenu, title) {
    const t = (title || "").toLowerCase();
    if (!t.includes("prix")) return;

    const minInput = submenu.querySelector('input[name*="price.gte"], input[name*="filter.v.price.gte"], input[id*="-min-"]');
    const maxInput = submenu.querySelector('input[name*="price.lte"], input[name*="filter.v.price.lte"], input[id*="-max-"]');
    if (!minInput || !maxInput) return;

    const priceBox = submenu.querySelector(".facets__price");
    if (priceBox) priceBox.style.display = "none";
    if (submenu.querySelector(".bh-price")) return;

    const minLimit = Number(minInput.min || 0);
    const maxLimit = Number(maxInput.max || maxInput.placeholder || 100000);
    const start = minInput.value ? Number(minInput.value) : minLimit;
    const end = maxInput.value ? Number(maxInput.value) : maxLimit;

    const fmt = new Intl.NumberFormat("fr-CH", { style: "currency", currency: "CHF", maximumFractionDigits: 0 });

    const wrap = document.createElement("div");
    wrap.className = "bh-price";
    wrap.innerHTML = `
      <div class="bh-line">
        <div class="bh-track"></div>
        <div class="bh-track-active"></div>
        <input class="bh-min" type="range" min="${minLimit}" max="${maxLimit}" value="${start}" step="10">
        <input class="bh-max" type="range" min="${minLimit}" max="${maxLimit}" value="${end}" step="10">
      </div>
      <div class="bh-labels">
        <span class="bh-min-label">${fmt.format(start)}</span>
        <span class="bh-max-label">${fmt.format(end)}</span>
      </div>
    `;
    submenu.insertBefore(wrap, submenu.firstChild);

    const rMin = wrap.querySelector(".bh-min");
    const rMax = wrap.querySelector(".bh-max");
    const active = wrap.querySelector(".bh-track-active");
    const minLbl = wrap.querySelector(".bh-min-label");
    const maxLbl = wrap.querySelector(".bh-max-label");

    function draw() {
      let v1 = +rMin.value, v2 = +rMax.value;
      if (v1 > v2) { const tmp = v1; v1 = v2; v2 = tmp; rMin.value = v1; rMax.value = v2; }

      const range = Math.max(1, maxLimit - minLimit);
      const p1 = ((v1 - minLimit) / range) * 100;
      const p2 = ((v2 - minLimit) / range) * 100;

      active.style.left = p1 + "%";
      active.style.width = (p2 - p1) + "%";

      minLbl.textContent = fmt.format(v1);
      maxLbl.textContent = fmt.format(v2);

      // update inputs Shopify + events
      minInput.value = v1;
      maxInput.value = v2;
      minInput.dispatchEvent(new Event("change", { bubbles: true }));
      maxInput.dispatchEvent(new Event("change", { bubbles: true }));
    }

    rMin.addEventListener("input", draw);
    rMax.addEventListener("input", draw);
    draw();
  }

function wireFooterButtons(submenu) {
  if (submenu.__bhWired) return;
  submenu.__bhWired = true;

  const applyBtn =
    submenu.querySelector('button[name="apply"]') ||
    submenu.querySelector('.mobile-facets__footer button[type="submit"]');

  const clearLink =
    submenu.querySelector('a.mobile-facets__clear') ||
    submenu.querySelector('facet-remove a');

  // Le vrai form (celui de Dawn)
  const form =
    currentForm ||
    document.getElementById("FacetFiltersFormMobile") ||
    document.querySelector("facet-filters-form form");

  function restoreSubmenuIntoFormIfNeeded() {
    // IMPORTANT : si le submenu a été déplacé dans #bhFacetPage2,
    // il faut le remettre dans son parent original (dans le form)
    try {
      if (movedNode && movedFrom && movedNode.parentElement !== movedFrom) {
        movedFrom.appendChild(movedNode);
      }
    } catch (e) {}
  }

  function buildUrlFromForm(formEl) {
    const url = new URL(window.location.href);

    // Supprime uniquement les filtres existants
    [...url.searchParams.keys()].forEach((k) => {
      if (k.startsWith("filter.")) url.searchParams.delete(k);
      if (k.includes("price.gte") || k.includes("price.lte")) url.searchParams.delete(k);
      if (k.includes("filter.v.price.gte") || k.includes("filter.v.price.lte")) url.searchParams.delete(k);
    });

    const fd = new FormData(formEl);
    for (const [k, v] of fd.entries()) {
      if (!k) continue;
      url.searchParams.append(k, v);
    }

    return url.toString();
  }

  function buildClearUrl() {
    const url = new URL(window.location.href);
    [...url.searchParams.keys()].forEach((k) => {
      if (k.startsWith("filter.")) url.searchParams.delete(k);
      if (k.includes("price.gte") || k.includes("price.lte")) url.searchParams.delete(k);
      if (k.includes("filter.v.price.gte") || k.includes("filter.v.price.lte")) url.searchParams.delete(k);
    });
    return url.toString();
  }

  // APPLIQUER
  if (applyBtn && form) {
    applyBtn.addEventListener(
      "click",
      function (e) {
        e.preventDefault();
        e.stopPropagation();

        // ✅ Remet le submenu dans le form AVANT de lire FormData
        restoreSubmenuIntoFormIfNeeded();

        // ✅ Construit l’URL avec les filtres réels
        const target = buildUrlFromForm(form);

        // (Optionnel) évite un état "page blanche" si ton overlay reste affiché
        try { closePage2(); } catch(e) {}

        window.location.href = target;
      },
      true
    );
  }

  // EFFACER
  if (clearLink) {
    clearLink.addEventListener(
      "click",
      function (e) {
        e.preventDefault();
        e.stopPropagation();

        restoreSubmenuIntoFormIfNeeded();

        const href = clearLink.getAttribute("href");
        try { closePage2(); } catch(e) {}

        window.location.href = href || buildClearUrl();
      },
      true
    );
  }

  // Garder le style “active” sur les carrés si besoin
  submenu
    .querySelectorAll('label.mobile-facets__label input[type="checkbox"]')
    .forEach((cb) => {
      cb.addEventListener("change", () => {
        const lab = cb.closest("label.mobile-facets__label");
        if (!lab) return;
        lab.classList.toggle("active", cb.checked);
      });
    });
}


  // ---------------- Open page2 ----------------
  function openFromDetails(detailsEl) {
    const ui = ensureUI();
    const submenu = detailsEl?.querySelector(".mobile-facets__submenu");
    if (!submenu) return;

    currentOpenDetails = detailsEl;
    currentForm = detailsEl.closest("form") || document.getElementById("FacetFiltersFormMobile") || null;

    const title =
      detailsEl.querySelector("summary span")?.textContent?.trim() ||
      detailsEl.querySelector("summary")?.textContent?.trim() ||
      "Filtre";

    ui.panel.querySelector("#bhFacetPage2Title").textContent = title;

    const body = ui.panel.querySelector("#bhFacetPage2Body");
    body.innerHTML = "";

    // Déplacer le vrai submenu (pas de clone)
    movedNode = submenu;
    movedFrom = submenu.parentElement;
    body.appendChild(submenu);

// BH: empêcher le bouton natif (retour/close) de Dawn de provoquer le "blanc"
const nativeBack = submenu.querySelector(".mobile-facets__close-button");
if (nativeBack) {
  nativeBack.style.display = "none"; // tu peux le cacher
  nativeBack.addEventListener("click", function(e){
    e.preventDefault();
    e.stopPropagation();
    closePage2();
  }, true);
}




    submenu.dataset.bhOrigStyle = submenu.getAttribute("style") || "";

    // Forcer visible
    submenu.style.cssText = `
      position: static !important;
      transform: none !important;
      visibility: visible !important;
      opacity: 1 !important;
      display: block !important;
      height: auto !important;
      overflow: visible !important;
      background: #fff !important;
    `;

    // Styles + slider + boutons
    applyBrandhubStyles(title, submenu);
    mountPriceSlider(submenu, title);
    wireFooterButtons(submenu);

    ui.overlay.style.display = "block";
    ui.panel.style.display = "flex";
  }

  // ---------------- Bind click page1 -> page2 ----------------
  function bind() {
    const drawer = document.getElementById("Details-FacetDrawer");
    if (!drawer) return;

    drawer.addEventListener("click", function (e) {
      const summary = e.target.closest("details.mobile-facets__details > summary.mobile-facets__summary");
      if (!summary) return;

      const detailsEl = summary.closest("details.mobile-facets__details");
      if (!detailsEl) return;

      e.preventDefault();
      e.stopPropagation();

      detailsEl.open = true;
      openFromDetails(detailsEl);
    }, true);
  }

  function boot() {
    bind();
    document.addEventListener("shopify:section:load", bind);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();


// === BH PATCH: close page2 must restore page1, no blank state ===
(function () {
  function restorePage1() {
    const drawer = document.getElementById("Details-FacetDrawer");
    if (!drawer) return;

    // s'assurer que le drawer reste ouvert
    try { drawer.open = true; } catch(e) {}

    // fermer tous les sous-details ouverts (Marque/Couleur/Prix...)
    drawer.querySelectorAll('details.mobile-facets__details[open]').forEach(d => {
      try { d.open = false; } catch(e) {}
      try { d.removeAttribute('open'); } catch(e) {}
    });

    // remettre le "page1" visible (sinon ça reste vide)
    const inner = drawer.querySelector(".mobile-facets__inner");
    if (inner) {
      inner.style.visibility = "visible";
      inner.style.opacity = "1";
      inner.style.transform = "none";
    }

    // sécurité: enlever un état "has-submenu-open" si présent
    const main = drawer.querySelector("#FacetsWrapperMobile");
    if (main) {
      main.classList.remove("has-submenu-open");
    }
  }

  // Quand on clique sur la croix du panneau page2
  document.addEventListener("click", (e) => {
    const closeBtn = e.target?.closest("#bhFacetPage2Close");
    if (!closeBtn) return;
    setTimeout(restorePage1, 0);
  }, true);

  // Quand on clique sur l'overlay
  document.addEventListener("click", (e) => {
    if (e.target && e.target.id === "bhFacetPage2Overlay") {
      setTimeout(restorePage1, 0);
    }
  }, true);

  console.log("BH restorePage1 patch loaded");


// BH — empêcher le close natif Dawn de laisser une page blanche
document.addEventListener('click', function(e){
  const inPage2 = e.target.closest('#bhFacetPage2');
  if(!inPage2) return;

  // tout ce qui ressemble à un "retour/close" natif dans le submenu
  const nativeClose = e.target.closest('.mobile-facets__close-button, .mobile-facets__close, button[aria-label="Fermer"], #bhFacetPage2Close');
  if(!nativeClose) return;

  e.preventDefault();
  e.stopPropagation();

  try { closePage2(); } catch(err){}
}, true);


})();
